import axios from 'axios';

/**
 * Auto-detect API base URL based on environment
 * - Development (Docker): http://localhost:8000
 * - Production (Fly.io): Same origin (relative paths)
 */
const getBaseURL = () => {
  // Check if running in development (Vite dev server on port 3000)
  const isDevelopment = import.meta.env.DEV;

  if (isDevelopment) {
    // Use environment variable or default to localhost:8000
    return import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';
  }

  // Production: frontend served by backend, use relative paths
  return '';
};

/**
 * Create axios instance with base configuration
 */
const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000, // 30 second timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request interceptor - Add auth token to all requests
 */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor - Handle common errors
 */
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - token expired or invalid
    if (error.response && error.response.status === 401) {
      // Clear auth token
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');

      // Redirect to login if not already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
